module.exports = __webpack_public_path__ + "img/Wp_2035.c097049b.png";